import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDrdMcCQ-axN3yS17gws3g3kOcVYZiSNY0',
    libraries: 'places',
  },
});
